<template>
  <div>
    <RadioMultiSelect
      :group="group"
      :label="laboratory.label"
      :values="laboratory.values"
      :value="value"
      :validate="validate"
      :required="required"
      :state="state"
      :message="message"
      @change="updateLaboratory"
    ></RadioMultiSelect>
    <LaboratoryQuestion :id="`${group}-question`" @input="emitQuestion"></LaboratoryQuestion>
  </div>
</template>

<script>
import RadioMultiSelect from "~/components/shared/RadioMultiSelect";
import LaboratoryQuestion from "~/components/events/components/LaboratoryQuestion";

export default {
  name: "LaboratorySurveyItem",
  components: {
    RadioMultiSelect,
    LaboratoryQuestion,
  },
  props: {
    laboratory: {
      type: Object,
      default: () => {},
    },
    group: {
      type: String,
      default: "",
    },
    updateLaboratory: {
      type: Function,
      default: () => {},
    },
    updateQuestion: {
      type: Function,
      default: () => {},
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Boolean, Number],
      default: "",
    },
    /**
     * Validate current state
     */
    validate: {
      type: Boolean,
      default: false,
    },

    /**
     * Initial error state
     */
    state: {
      type: String,
      default: "",
    },

    /**
     * Initial error message
     */
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    emitQuestion(value) {
      this.updateQuestion({ target: { name: this.group, value } });
    },
  },
};
</script>

<style></style>
